import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { createAndRedirectToNewHub } from "../../utils/phoenix-utils";
import { Button } from "../input/Button";
import { useCssBreakpoints } from "react-use-css-breakpoints";
import styles from "./CreateRoomButton.scss";

export function CreateRoomButton() {
  const breakpoint = useCssBreakpoints();
  const [notice, setNotice] = useState(null);
  const isPreview = process.env.IS_UI_PREVIEW || window.location.port === "4173";

  const createRoom = async event => {
    event.preventDefault();

    try {
      setNotice(null);
      await createAndRedirectToNewHub(null, null, false);
    } catch (error) {
      console.error("Room creation failed", error);
      setNotice("We could not create the room. Check your connection and try again.");
    }
  };

  return (
    <div className={styles.createRoomAction}>
      <Button
        as={isPreview ? "a" : "button"}
        href={isPreview ? "/?demo=event-details" : undefined}
        thick={breakpoint === "sm" || breakpoint === "md"}
        xl={breakpoint !== "sm" && breakpoint !== "md"}
        preset="landing"
        onClick={isPreview ? undefined : createRoom}
      >
        {isPreview ? (
          <FormattedMessage id="create-event-button" defaultMessage="Create event" />
        ) : (
          <FormattedMessage id="create-room-button" defaultMessage="Create Room" />
        )}
      </Button>
      {notice && (
        <div className={styles.previewNotice} role="status">
          {notice}
        </div>
      )}
    </div>
  );
}
